import React from 'react'
import { useSelector } from 'react-redux';

const Spinner = (props) => {
  const spinner = useSelector(state => state.spinner);
  if (spinner) return <div id='loading'><div className='loadingMsg'></div></div>
  else return <></>
}

export default React.memo(Spinner)
